import React, { useEffect, useState } from 'react';
import CartCommon from "src/component/Global/Cart/Common";
import CartRepository from "src/repository/CartRepository";
import QuantityPicker from "./QuantityPicker";
import { useDispatch } from "react-redux";
import useDebounce from "../../../hooks/useDebounce";
import System from "../../../helper/system";
import { SET_OBSOLETE_EOL_INVALID_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT, SET_CART_LOADER_DATA_OBJECT } from "../../../store/slice/model/Cart";
import FadeInOut from "../../FadeInOut";
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import { useCartStore } from 'src/hooks/cart';
import store from 'src/storeWire';
import { Tooltip } from 'src/component/Tooltip';

const QuantityPickerForUpdateCart = (props) => {
    const {
        single_product,
        single_product_pricing_list,
        single_product_inventory,
        single_cart_data
    } = props;
    const [ObsoleteFailedFlag, setObsoleteFailedFlag] = useState(true);
    const [EndOfLifeOFlagFailedFlag, setEndOfLifeOFlagFailedFlag] = useState(true);
    const [{ }, { }, { SET_CART_DATA_ERROR }] = useCartStore();
    const dispatch = useDispatch();
    const [countQuantityPicker, setCountQuantityPicker] = useDebounce(0, 1000)

    useEffect(() => {
        async function f() {
            if (countQuantityPicker > 0) {
                await updateToCartServer(countQuantityPicker);
            }
        }
        f();
    }, [countQuantityPicker]);

    const obsoleteEOLValidationReduxDispatch = (status = true) => {
        store.dispatch(SET_OBSOLETE_EOL_INVALID_CART_BEFORE_TO_SEND_SERVER_SINGLE_PRODUCT({
            CART_DATA: {
                ItemNumber: single_product.ItemNumber,
                obsolete_EOL_invalidate_message_active: status,
            }
        }));
    }
    const updateToCartServer = async (quantityUpdateToCartInput) => {
        dispatch(SET_CART_LOADER_DATA_OBJECT({ ...single_product, isUpdatingCpnType: !single_product?.isUpdatingCpnType }))

        let flag = new CartCommon().getObsoleteFailedFlag(single_product, quantityUpdateToCartInput, single_product_inventory);
        // let flag_EndOfLifeOFlagFailedFlag = new CartCommon().getEndOfLifeOFlagFailedFlag(single_product, quantityUpdateToCartInput, single_product_inventory);
        if (flag === true) {
            setObsoleteFailedFlag(false);
            SET_CART_DATA_ERROR(true);
            obsoleteEOLValidationReduxDispatch()

            System.popup('ObsoleteOutOfStockPopup', {
                ERPMFRPartNumber: single_product.ERPMFRPartNumber, ObsoleteFlag: single_product.ObsoleteFlag, quantity: single_product_inventory.quantity
            });
            return false;
        }

        setEndOfLifeOFlagFailedFlag(true);
        setObsoleteFailedFlag(true);
        SET_CART_DATA_ERROR(false);

        if (single_cart_data && quantityUpdateToCartInput > 0) {
            let quantityUpdateToCartHere = parseFloat(quantityUpdateToCartInput);
            if (single_product.ERPPartNumber !== undefined && quantityUpdateToCartHere > 0) {
                let p = {
                    "partNumber": single_product.ERPPartNumber,
                    "quantity": quantityUpdateToCartHere,
                    "cartDetailId": single_cart_data.cartDetailId,
                };
                if (single_cart_data.backOrderedQuantity && single_cart_data.backOrderedQuantity > 0) {
                    let b_q = quantityUpdateToCartInput - new CartRepository().getInventoryQuantity(single_cart_data.ERPPartNumber);
                    if (b_q < 1) {
                        b_q = 0;
                    }
                    p.backOrderedQuantity = b_q;
                    p.backOrderQuantity = b_q;
                    p.quantity = quantityUpdateToCartInput;
                }
                obsoleteEOLValidationReduxDispatch(false)
                await new CartRepository().updateToCartServer(p);
            }
        }
    };
    const [__check] = useAxiosIndicatorCheck();
    return (
        <>
            {single_cart_data && single_product &&
                <QuantityPicker
                    {...props}
                    invalid_quantity_message_text={"The quantity you've selected does not meet our minimum/multiple order requirements. Please re-enter your desired quantity."}
                    is_default_invalid_quantity={true}
                    readOnly_quantity={__check(['CART_API_CALL', 'CART_OPERATION_API_CALL']).status}
                    CHECK_CART_RELATED_INVENTORY_VALIDATION={true}
                    single_product_pricing_list={single_product_pricing_list}
                    show_validation_message_Insufficient_Inventory={false}
                    force_default_quantity={single_cart_data.quantity}
                    adjustedQty={single_cart_data?.adjustedQuantity}
                    backOrderQty={single_cart_data.backOrderedQuantity}
                    disable_edit_force_default_quantity={true}
                    ObsoleteFlag={ObsoleteFailedFlag}
                    EndOfLifeFlag={EndOfLifeOFlagFailedFlag}
                    getPlanInputQuantityValidatedCallback={async (count) => {
                        setCountQuantityPicker(count)
                    }}
                    min_inv_validation={true}
                />
            }
            <FadeInOut
                show={ObsoleteFailedFlag === false}
                duration={250} >
                <span className="mandatory">Insufficient Inventory.</span>
            </FadeInOut>
            <FadeInOut
                show={EndOfLifeOFlagFailedFlag === false}
                duration={250} >
                <span className="mandatory">Insufficient Inventory.</span>
            </FadeInOut>
            <FadeInOut
                show={single_cart_data.quantity < single_cart_data.adjustedQuantity}
                duration={250} >
                <span className="mandatory">Price mismatch</span>
                <Tooltip position={'right'}
                    opener={() => (<i className="fa fa-info-circle ms-1 font-13" />)}
                    content={() => (<>There is a Price Mismatch between the Min/Mult and available tier price. To proceed, please update the quantity to the correct tier price quantity or remove the item from your cart.</>)}
                />
            </FadeInOut>
        </>
    );
}

export default QuantityPickerForUpdateCart;